import { MutationTree } from 'vuex';
import { UndergradSubmoduleState } from '@/store/undergrad/submodules/state';

const mutations: MutationTree<UndergradSubmoduleState> = {
  SET_UNDERGRAD_SUBMODULES(state: UndergradSubmoduleState, entities: UndergradSubmoduleState) {
    if (!entities.undergradSubmodules) {
      state.undergradSubmodules = {};
      return;
    }

    state.undergradSubmodules = entities.undergradSubmodules;
  },
};

export default mutations;
